import React from 'react';
import {
  Select as BaseSelect,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultipleSelect = (props) => {
  const { items, value, onChange, label, ...formControlProps } = props;

  return (
    <FormControl variant="outlined" {...formControlProps}>
      <InputLabel>{label}</InputLabel>
      <BaseSelect
        label={label}
        multiple
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        MenuProps={MenuProps}
      >
        {items.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </BaseSelect>
    </FormControl>
  );
};

MultipleSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.array, 
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default MultipleSelect;